import React from "react";

const TabNavigation = ({ tabs, activeTab, onTabChange, disabledTabs = [] }) => {
  return (
    <div className="flex bg-white border-t-2 border-borderBlue">
      {tabs.map((tab, index) => {
        const isDisabled = disabledTabs.includes(tab.id);
        const isActive = activeTab === tab.id;

        return (
          <React.Fragment key={tab.id}>
            <button
              onClick={() => !isDisabled && onTabChange(tab.id)}
              disabled={isDisabled}
              className={`flex items-center justify-center py-2 !pr-10 !pl-10 font-normal text-xl transition-colors duration-200 relative ${
                isActive
                  ? "bg-customLightBlue text-customBlue"
                  : isDisabled
                  ? "bg-gray-100 text-gray-300 cursor-not-allowed"
                  : "bg-white hover:bg-gray-50 text-gray-400"
              }`}
            >
              {tab.label}
              <div className="absolute right-0 top-0 bottom-0 w-[2px] bg-customGrey"></div>
            </button>
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default TabNavigation;
